import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useState } from 'react'
import { useEffect } from 'react'

import FormGroup from '../../../components/ReusableComponents/ManageHotel/FormGroup/index'
import Toggle from '../../../components/ReusableComponents/Toggle/index'
import useFirstRender from '../../../hooks/useFirstRender'
import Autocomplete from '../PlacesAutocomplete/index'
import styles from './InvoiceAndBilling.module.scss'

const InvoiceAndBilling = ({
  formData: { billingAddress, invoiceAddress, invoiceTo },
  setFormData,
  handleValidated,
  valid,
  limited
}) => {
  const [isBillingValid, setBillingValid] = useState()
  const [isInvoiceValid, setInvoiceValid] = useState()
  const [hasSameAddress, setHasSameAddress] = useState(limited ? false : true)

  useFirstRender(() => {
    if (billingAddress && billingAddress !== invoiceAddress) {
      setHasSameAddress(false)
    }
  })

  function setInvoiceAddress(invoiceAddress) {
    if (hasSameAddress) {
      setFormData({ billingAddress: invoiceAddress })
    }

    setFormData({ invoiceAddress })
  }

  function handleToggleChange(e) {
    if (e.target.checked && billingAddress) {
      setFormData({ invoiceAddress: billingAddress })
    }

    if (!e.target.checked) {
      setFormData({ billingAddress: '' })
    }

    setHasSameAddress(!e.target.checked)
  }

  useEffect(() => {
    let isValid

    if (limited) {
      isValid = isBillingValid
    } else {
      isValid = isInvoiceValid && (hasSameAddress ? true : isBillingValid)
    }

    handleValidated(isValid)
  }, [handleValidated, hasSameAddress, isBillingValid, isInvoiceValid, limited])

  return (
    <FormGroup title="Invoice and billing" done={valid}>
      {!limited && (
        <Autocomplete
          label={
            hasSameAddress
              ? 'Billing and invoice address'
              : 'Invoice address (hotel location)'
          }
          className={styles.addressInput}
          value={invoiceAddress}
          setValue={setInvoiceAddress}
          setTimeZoneName={
            hasSameAddress
              ? tzTimeZoneName => setFormData({ tzTimeZoneName })
              : () => null
          }
          setAddressObj={
            hasSameAddress ? addressObj => setFormData({ ...addressObj }) : () => null
          }
          valid={isInvoiceValid}
          setValid={setInvoiceValid}
        />
      )}

      {!hasSameAddress && (
        <Box>
          <Autocomplete
            label="Billing address"
            className={styles.addressInput}
            value={hasSameAddress ? billingAddress : invoiceAddress}
            setValue={billingAddress => setFormData({ billingAddress })}
            setTimeZoneName={tzTimeZoneName => setFormData({ tzTimeZoneName })}
            setAddressObj={addressObj => setFormData({ ...addressObj })}
            valid={isBillingValid}
            setValid={setBillingValid}
            disabled={hasSameAddress}
          />
        </Box>
      )}
      <Box>
        <TextInput
          name="invoiceTo"
          label="Invoice to"
          style={{ width: 236 }}
          value={invoiceTo}
          onChange={e => setFormData({ invoiceTo: e.target.value })}
        />
      </Box>

      {!limited && (
        <Toggle
          label="Has different billing and invoice addresses"
          className={styles.toggle}
          isGray
          handleChange={handleToggleChange}
          checked={!hasSameAddress}
        />
      )}
    </FormGroup>
  )
}

const Box = ({ children }) => <form onSubmit={e => e.preventDefault()}>{children}</form>

export default InvoiceAndBilling
